import { useEffect, useState } from "react";
import { GADimensions, GAEvents, InstallmentType, formActionTypes } from "../../../interfaces/interfaces";
import styles from './LoanForm.module.scss';
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import { AiOutlineClose as CloseIcon } from "react-icons/ai";
import CircularLoader from "../../../components/common/CircularLoader/CircularLoader";
import { Field, Form } from "react-final-form";
import arrayMutators from 'final-form-arrays'
import { GASendEvent, getLocalUser, onBlurFormatNumber, parseNumberForDB, setFieldTouchedMutator } from "../../../components/functions/utilities";
import OutlinedFormInput from "../components/OutlinedFormInput/OutlinedFormInput";
import { Modal } from "reactstrap";
import MeritoDateField from "../components/DateField/MeritoDateField";
import LoanFormInstallment from "./LoanFormInstallment";
import dayjs from "dayjs";
import moment from "moment";
import ConfirmDialog from "../../../components/common/ConfirmDialog";
import { FaCircleExclamation as Exclamation } from "react-icons/fa6";
import { RestS } from "../../../rest/rest-service";
import { RiDeleteBin6Line as DeleteIcon } from 'react-icons/ri'
import DatesErrorField from "./DatesErrorField";
import { OnChange } from "react-final-form-listeners";

type Props = {
    isOpen: boolean;
    setOpen: (value: boolean) => void;
    closeForm: (fetchTabs?: boolean) => void;
    actionType: formActionTypes;
    categoryId: number;
    categoryName: string;
    monthLabels: string[];
    formMetricId: number;
    ipConfigs: { [x: string]: string };
    formHeaderTitle?: {
        editTitle: string,
        addTitle: string,
    }
}

export enum datesError {
    withingRange = 'Either the Start or End Date should be within the last 12 months',
}


const LoanForm = ({ isOpen, setOpen, closeForm, actionType, categoryId, categoryName, monthLabels, formMetricId, ipConfigs, formHeaderTitle }: Props) => {
    const [initialValues, setInitialValues] = useState({})
    const [loading, setLoading] = useState(false);
    const [previousDates, setPreviousDates] = useState({
        startDate: null,
        endDate: null,
    })
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [deleteBtnLoading, setDeleteBtnLoading] = useState(false);
    const [datesInvalidated, setDatesInvalidated] = useState(false);
    const [initialMonthsObj, setInitialMonthsObj] = useState({});
    let user = getLocalUser();

    const loanFormEditValues = async () => {
        try {
            setLoading(true);
            const { loanData } = await RestS.fetchLoanDetails(formMetricId);
            const formattedInitialValues = {
                lenderName: loanData?.lenderName,
                loanAmount: loanData?.loanAmount,
                interestRate: loanData?.interestRate,
                outstandingAmount: loanData?.outstandingAmount,
                outstandingAmountEnteredDate: loanData?.outstandingAmountEnteredDate,
                outstandingAmountEnteredOn: loanData?.outstandingAmountEnteredOn,
                startDate: loanData?.startDate ? moment(loanData?.startDate, "MM-YYYY").clone().toDate() : null,
                endDate: loanData?.endDate ? moment(loanData?.endDate, "MM-YYYY").clone().toDate() : null,
                installmentType: loanData?.installmentType,
                installmentAmount: loanData?.installmentAmount,
                months: loanData?.startDate && loanData?.endDate ? formatFormEditValues(loanData) : [],
            }
            // console.log('formattedInitialValues', formattedInitialValues);
            setInitialValues(formattedInitialValues)
            setLoading(false)
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
    }


    useEffect(() => {
        if (actionType == formActionTypes.add) {
            // setInitialValues({
            setInitialValues({
                installmentType: InstallmentType.fixed,
                installmentAmount: ''
            })
        } else if (actionType == formActionTypes.edit) {
            loanFormEditValues();
        }
    }, []);


    const validateBothDates = (startDate: Date, endDate: Date, checkAllFields = false, allValues: { [x: string]: any } = null) => {
        const cyStart = moment(monthLabels[monthLabels.length - 1], "MM-YYYY").toDate();
        const cyEnd = moment(monthLabels[0], 'MM-YYYY').toDate();
        let errors = {};
        const isBothDatePresent = startDate && endDate;
        if (checkAllFields && allValues != null) {
            if (!allValues['lenderName']) {
                errors['lenderName'] = `Enter Lender's Name`
            }
            if (!allValues['loanAmount']) {
                errors['loanAmount'] = `Enter Loan Amount`
            }
            if (!allValues['interestRate']) {
                errors['interestRate'] = `Enter Interest Rate`
            }
        }
        if (!startDate) {
            errors['startDate'] = `Enter Repayment Start Date`
        }
        if (!endDate) {
            errors['endDate'] = `Enter Repayment End Date`
        }
        if (isBothDatePresent && dayjs(startDate).isAfter(dayjs(endDate))) {
            errors['startDate'] = `Start Date must be before End Date.`
        }
        if (isBothDatePresent && dayjs(endDate).isBefore(dayjs(startDate))) {
            errors['endDate'] = `End Date must be after Start Date.`
        }
        if (isBothDatePresent && dayjs(startDate).isSame(dayjs(endDate))) {
            errors['startDate'] = `Start Date and End Date cannot be same.`
            errors['endDate'] = `Start Date and End Date cannot be same.`
        }
        // const isStartInRange = dayjs(startDate).isAfter(cyStart) && dayjs(startDate).isBefore(cyEnd);

        // const isEndInRange = dayjs(endDate).isAfter(cyStart) && dayjs(endDate).isBefore(cyEnd);
        // console.log('isStartInRange', isStartInRange, 'isEndInRange', isEndInRange)
        const isNotInRange = dayjs(startDate).isBefore(cyStart) && dayjs(endDate).isBefore(cyStart) || dayjs(startDate).isAfter(cyEnd) && dayjs(endDate).isAfter(cyEnd);
        // console.log('isNotInRange', isNotInRange, 'startDate', startDate, 'endDate', endDate, 'cyStart', cyStart, 'cyEnd', cyEnd)
        if (isBothDatePresent && isNotInRange) {
            console.log('coming in within range')
            errors['startDate'] = datesError.withingRange
            errors['endDate'] = datesError.withingRange
        }
        return {
            errorsObj: errors,
            isError: Object.keys(errors).length > 0
        }
    }

    const handleVariableMonths = (values: { [x: string]: any }, batch: any, change: any, forceChange = false) => {
        const startDate = values['startDate'];
        const endDate = values['endDate'];

        const calendarStartYear = moment(monthLabels[monthLabels.length - 1], "MM-YYYY").toDate();
        let startMonth = dayjs(startDate);
        if (dayjs(startDate).isBefore(dayjs(calendarStartYear))) {
            // console.log('startDate', startDate, 'calendarStartYear', calendarStartYear)
            startMonth = dayjs(calendarStartYear);
        }
        const endMonth = dayjs(endDate);

        const unFormattedStart = dayjs(startDate).clone().format("MM-YYYY");
        const unFormattedEnd = dayjs(endDate).clone().format("MM-YYYY");



        const monthDiff = dayjs(endMonth).diff(dayjs(startMonth), 'months');
        // console.log('monthDiff', monthDiff, 'endMonth', endMonth, 'startMonth', startMonth);

        // console.log('monthDiff', monthDiff);
        if (monthDiff > 0) {
            const dummyArr = new Array(monthDiff + 1).fill("empty");
            const formattedStart = dayjs(startMonth).clone().format("MM-YYYY");
            const formattedEnd = dayjs(endDate).clone().format("MM-YYYY");
            if (previousDates?.startDate != unFormattedStart || previousDates?.endDate != unFormattedEnd || forceChange) {
                setPreviousDates({
                    startDate: dayjs(startDate).clone().format("MM-YYYY"),
                    endDate: dayjs(endMonth).clone().format("MM-YYYY"),
                })

                const initialStart = moment(initialValues['startDate'], "MM-YYYY").clone().format("MM-YYYY");
                const initialEnd = moment(initialValues['endDate'], "MM-YYYY").clone().format("MM-YYYY");
                let isDatesDirty = datesInvalidated;



                let isDateSameAsInitial = initialStart == unFormattedStart && initialEnd == unFormattedEnd;
                if (!datesInvalidated && (initialStart != unFormattedStart || initialEnd != unFormattedEnd)) {
                    setDatesInvalidated(true);
                    isDatesDirty = true;
                }

                const monthFields = [];
                let previousYear = moment(formattedStart, "MM-YYYY").clone().format("YYYY");
                console.log('isDateSameAsInitial', isDateSameAsInitial, 'isDatesDirty', isDatesDirty, 'initialValues', initialValues, values?.installmentType)
                dummyArr.forEach((item, index) => {
                    if (index == 0) {
                        if (isDateSameAsInitial && !isDatesDirty && values?.installmentType == initialValues['installmentType']) {
                            const monthValue = initialMonthsObj[formattedStart];
                            monthFields.push({
                                monthYear: formattedStart,
                                installmentAmount: monthValue ? parseNumberForDB(monthValue.installmentAmount) : null,
                            })
                        } else {
                            monthFields.push({
                                monthYear: formattedStart,
                                installmentAmount: '',
                                isSeparator: false,
                            })
                        }
                    } else {
                        const currentMonthYear = moment(formattedStart, "MM-YYYY").clone().add(index, 'months').format("MM-YYYY");
                        const currentYear = moment(currentMonthYear, "MM-YYYY").clone().format("YYYY");
                        let isSeparator = false
                        if (currentYear != previousYear) {
                            isSeparator = true;
                            previousYear = currentYear;
                        }
                        if (isDateSameAsInitial && !isDatesDirty && values?.installmentType == initialValues['installmentType']) {
                            const monthValue = initialMonthsObj[currentMonthYear];
                            monthFields.push({
                                monthYear: currentMonthYear,
                                installmentAmount: monthValue ? parseNumberForDB(monthValue.installmentAmount) : null,
                                isSeparator: isSeparator,
                            })
                        } else {
                            monthFields.push({
                                monthYear: currentMonthYear,
                                installmentAmount: '',
                                isSeparator: isSeparator,
                            })
                        }

                    }
                })

                // console.log('monthsFields', monthFields);

                batch(() => {
                    if (values?.installmentType == InstallmentType.fixed) {
                        change(`installmentAmount`, monthFields[0]['installmentAmount']);
                    }
                    change(`months`, monthFields);
                })



            }



        }
    }


    const deleteLoan = async () => {
        console.log('delete Loan', deleteLoan);
        try {
            setDeleteBtnLoading(true);
            const deletedData = await RestS.deleteLoanDetails(formMetricId);
            closeForm(true)
        } catch (error) {
            console.log('error');
            closeForm();
        } finally {
            setDeleteBtnLoading(false);
        }
    }

    const sendPnlUpdateGaEvent = (pnlUpdateType) => {
        GASendEvent(user, GAEvents.pnl_update, {
            [GADimensions.userLoginId]: user.id,
            [GADimensions.userType]: user.role,
            [GADimensions.pnl_type]: pnlUpdateType,
            [GADimensions.companyId]: user.companyId,
            [GADimensions.companyName]: user.companyName,
        });
    }


    const handleSubmitForm = async (values) => {
        // console.log('values', values);
        // return;
        if (actionType == formActionTypes.add) {
            const finalValues = {
                ...values,
                outstandingAmount: parseNumberForDB(values?.outstandingAmount),
                loanAmount: parseNumberForDB(values.loanAmount),
                interestRate: parseNumberForDB(values.interestRate, true),
                startDate: dayjs(values.startDate).clone().format("MM-YYYY"),
                endDate: dayjs(values.endDate).clone().format("MM-YYYY"),
                categoryId,
                months: values?.installmentType == InstallmentType.fixed ? formatMonthsForFixed(values) : values?.months,
            }
            console.log('finalValues', finalValues)
            const insertedData = await RestS.insertLoanDetails(finalValues);
            if (insertedData) {
                closeForm(true);
                sendPnlUpdateGaEvent('loan_add')
            }
        } else {
            const finalValues = {
                ...values,
                outstandingAmount: parseNumberForDB(values?.outstandingAmount),
                loanAmount: parseNumberForDB(values.loanAmount),
                interestRate: parseNumberForDB(values.interestRate, true),
                startDate: dayjs(values.startDate).clone().format("MM-YYYY"),
                endDate: dayjs(values.endDate).clone().format("MM-YYYY"),
                categoryId,
                months: values?.installmentType == InstallmentType.fixed ? formatMonthsForFixed(values) : values?.months,
                metricId: formMetricId,
            }
            console.log('finalValues', finalValues)
            const updatedData = await RestS.updateLoanDetails(finalValues);
            if (updatedData) {
                closeForm(true);
                sendPnlUpdateGaEvent('loan_update')
            }
        }
    }


    const formatMonthsForFixed = (values) => {
        const startDate = dayjs(values.startDate);
        const endDate = dayjs(values.endDate);
        let startMonth = dayjs(startDate);
        const calendarStartYear = moment(monthLabels[monthLabels.length - 1], "MM-YYYY").toDate();
        const calendarEndYear = moment(monthLabels[0], "MM-YYYY").toDate();
        if (dayjs(startDate).isBefore(dayjs(calendarStartYear))) {
            // console.log('startDate', startDate, 'calendarStartYear', calendarStartYear)
            startMonth = dayjs(calendarStartYear);
        }
        let endMonth = dayjs(endDate);
        if (dayjs(endDate).isAfter(dayjs(calendarEndYear))) {
            endMonth = dayjs(calendarEndYear);
        }
        console.log('endMonth', endMonth, 'startMonth', startMonth)
        const monthDiff = dayjs(endMonth).diff(dayjs(startMonth), 'months');
        // if(monthDiff > 0) {

        const dummyArr = new Array(monthDiff + 1).fill("empty");
        const formattedStart = dayjs(startMonth).clone().format("MM-YYYY");
        const formattedEnd = dayjs(endMonth).clone().format("MM-YYYY");
        const monthFields = [];
        let previousYear = moment(formattedStart, "MM-YYYY").clone().format("YYYY");
        dummyArr.forEach((item, index) => {
            if (index == 0) {
                monthFields.push({
                    monthYear: formattedStart,
                    installmentAmount: parseNumberForDB(values.installmentAmount),
                })
            } else {
                const currentMonthYear = moment(formattedStart, "MM-YYYY").clone().add(index, 'months').format("MM-YYYY");
                monthFields.push({
                    monthYear: currentMonthYear,
                    installmentAmount: parseNumberForDB(values.installmentAmount),
                })
            }
        })
        return monthFields;
        // }
    }

    const formatFormEditValues = (values: any) => {
        const isFixed = values?.installmentType == InstallmentType.fixed;
        const startDate = moment(values.startDate, "MM-YYYY").clone().toDate();
        const endDate = moment(values.endDate, "MM-YYYY").clone().toDate();
        let startMonth = dayjs(startDate);

        console.log('startDate', startDate, 'endDate', endDate)
        const calendarStartYear = moment(monthLabels[monthLabels.length - 1], "MM-YYYY").toDate();
        const calendarEndYear = moment(monthLabels[0], "MM-YYYY").toDate();
        if (dayjs(startDate).isBefore(dayjs(calendarStartYear))) {
            startMonth = dayjs(calendarStartYear);
        }
        let endMonth = dayjs(endDate);
        // if (dayjs(endDate).isAfter(dayjs(calendarEndYear))) {
        //     endMonth = dayjs(calendarEndYear);
        // }
        const monthsObj = values?.months && values?.months.length ? values?.months.reduce((prev, curVal) => {
            prev[curVal?.monthYear] = curVal;
            return prev;
        }, {}) : {}

        const monthDiff = dayjs(endMonth).diff(dayjs(startMonth), 'months');
        // if(monthDiff > 0) {

        console.log('monthDiff', monthDiff, 'endMonth', endMonth, 'startMonth', startMonth)

        const dummyArr = new Array(monthDiff + 1).fill("empty");
        const formattedStart = dayjs(startMonth).clone().format("MM-YYYY");
        const formattedEnd = dayjs(endMonth).clone().format("MM-YYYY");
        const monthFields = [];
        let previousYear = moment(formattedStart, "MM-YYYY").clone().format("YYYY");
        dummyArr.forEach((item, index) => {

            if (index == 0) {
                const monthValue = monthsObj[formattedStart];
                monthFields.push({
                    monthYear: formattedStart,
                    installmentAmount: monthValue ? parseNumberForDB(monthValue.installmentAmount) : null,
                    isSeparator: false,
                })
            } else {
                const currentMonthYear = moment(formattedStart, "MM-YYYY").clone().add(index, 'months').format("MM-YYYY");
                const monthValue = monthsObj[currentMonthYear];
                const currentYear = moment(currentMonthYear, "MM-YYYY").clone().format("YYYY");
                let isSeparator = false
                if (currentYear != previousYear) {
                    isSeparator = true;
                    previousYear = currentYear;
                }
                monthFields.push({
                    monthYear: currentMonthYear,
                    installmentAmount: monthValue ? parseNumberForDB(monthValue.installmentAmount) : null,
                    isSeparator: isSeparator,
                })
            }
        });
        console.log('monthFields', monthFields);
        setInitialMonthsObj(monthsObj)
        return monthFields;
    }




    return (
        <Modal size="md" centered isOpen={isOpen} toggle={() => {
            closeForm();
        }}>
            <div className={styles.formRootContainer}>
                <div className={styles.headerContainer}>
                    <div className={styles.title}>
                        {actionType == formActionTypes.add ? `Add ${categoryName}` : formHeaderTitle?.editTitle}
                    </div>
                    <div className={styles.actionButtonContainer}>
                        <MeritoButton type="secondary-1" icon={<CloseIcon />} onlyIcon={true} onClick={(e) => {
                            e.stopPropagation();
                            closeForm();
                        }} />
                    </div>
                </div>
                {loading ?
                    <>
                        <div className={styles.loadingContainer}>
                            <CircularLoader
                            // backgroundColor={
                            //     feedFor === InsightFeedFor.goalsHub ? "white" : "#f0eff4"
                            // }
                            />
                        </div>

                        <div className={styles.footerContainer}>
                            <MeritoButton btnText="Cancel" type="tertiary" onClick={() => { }} />
                            <MeritoButton btnText="Add" type="primary-1" onClick={() => { }} />
                        </div>
                    </>
                    :
                    <Form
                        initialValues={initialValues}
                        mutators={{
                            ...arrayMutators,
                            setFieldTouched: setFieldTouchedMutator
                        }}
                        validate={(values) => {
                            let errors = {};
                            const startDate = values['startDate'];
                            const endDate = values['endDate'];
                            const datesValidationResult = validateBothDates(startDate, endDate);
                            if (validateBothDates(startDate, endDate).isError) {
                                errors = {
                                    ...errors,
                                    ...datesValidationResult?.errorsObj,
                                }
                            }

                            if (values?.installmentType == InstallmentType.variable && values.months && values.months.length) {
                                const isValuePresent = values.months.some((item) => item?.installmentAmount != null && item?.installmentAmount != "");
                                // console.log('isValuePresent', isValuePresent)
                                if (!isValuePresent) {
                                    return {
                                        ...errors,
                                        months: values.months.map(() => {
                                            return {
                                                installmentAmount: 'Enter at least one month’s Instalment Amount'
                                            }
                                        })
                                    }
                                }
                            }
                            return errors;
                        }}
                        onSubmit={handleSubmitForm}
                        render={({ values, handleSubmit, pristine, hasValidationErrors, form: { change, batch, mutators } }) => {
                            return (
                                <form onSubmit={handleSubmit}>
                                    <div className={styles.formBodyContainer}>
                                        <Field name="lenderName"
                                            validate={(value) => {
                                                if (!value) {
                                                    return `Enter Lender's Name`
                                                }
                                            }}>
                                            {(props) => (
                                                <OutlinedFormInput
                                                    {...props.input}
                                                    label="Name of the Lender"
                                                    name={props.input.name}
                                                    value={props.input.value}
                                                    onChange={props.input.onChange}
                                                    error={props.meta.error}
                                                    touched={props.meta.touched}
                                                    maxLength={70}
                                                />
                                            )}
                                        </Field>
                                        <Field name="loanAmount"
                                            validate={(value) => {
                                                if (!value) {
                                                    return `Enter Loan Amount`
                                                }
                                            }}>
                                            {(props) => (
                                                <OutlinedFormInput
                                                    {...props.input}
                                                    label="Loan Amount"
                                                    showError={true}
                                                    inpuType="number"
                                                    name={props.input.name}
                                                    value={props.input.value}
                                                    onChange={(e) => {
                                                        const numericValue = parseNumberForDB(e.target.value, false);
                                                        // console.log('numeric value', numericValue)
                                                        props.input.onChange(numericValue);
                                                    }}
                                                    error={props.meta.error}
                                                    touched={props.meta.touched}
                                                    onBlur={(e) => {
                                                        const value = props.input.value;
                                                        // console.log('value', value);
                                                        const formattedValue = onBlurFormatNumber(value, 0);
                                                        props.input.onChange(formattedValue);
                                                        // console.log('inputValue', value)
                                                        props.input.onBlur(e);
                                                    }}
                                                    unitPlaceHolder={'₹'}
                                                    maxLength={21}
                                                    isCurrency={true}
                                                />
                                            )}
                                        </Field>

                                        <div className={styles.fieldFlexRootContainer}>
                                            <div className={styles.outerFieldContainer}>
                                                <Field name="outstandingAmount"
                                                    validate={(value) => {
                                                        if (!value) {
                                                            return `Enter Amount`
                                                        }
                                                    }}>
                                                    {(props) => (
                                                        <OutlinedFormInput
                                                            {...props.input}
                                                            label="Outstanding Principal Amount"
                                                            showError={true}
                                                            inpuType="number"
                                                            placeholder="Enter Amount"
                                                            name={props.input.name}
                                                            value={props.input.value}
                                                            onChange={(e) => {
                                                                const numericValue = parseNumberForDB(e.target.value, false);
                                                                // console.log('numeric value', numericValue)
                                                                props.input.onChange(numericValue);
                                                            }}
                                                            error={props.meta.error}
                                                            touched={props.meta.touched}
                                                            onBlur={(e) => {
                                                                const value = props.input.value;
                                                                // console.log('value', value);
                                                                const formattedValue = onBlurFormatNumber(value, 0);
                                                                props.input.onChange(formattedValue);
                                                                // console.log('inputValue', value)
                                                                props.input.onBlur(e);
                                                            }}
                                                            unitPlaceHolder={'₹'}
                                                            maxLength={21}
                                                            isCurrency={true}
                                                            subText={values?.outstandingAmountEnteredDate && dayjs(values?.outstandingAmountEnteredDate).isValid() ? `Last Updated: ${dayjs(values?.outstandingAmountEnteredDate).format("MMM DD, YYYY")}` : null}
                                                        />
                                                    )}
                                                </Field>
                                                <OnChange name="outstandingAmount">
                                                    {(value, previous) => {
                                                        if (value || value == 0) {
                                                            change('outstandingAmountEnteredOn', moment().format("MM-YYYY"))
                                                        }
                                                    }}
                                                </OnChange>
                                            </div>
                                            <div className={styles.outerFieldContainer}>
                                                <Field name="interestRate"
                                                    validate={(value) => {
                                                        if (!value) {
                                                            return `Enter Interest Rate`
                                                        }
                                                    }}>
                                                    {(props) => (
                                                        <OutlinedFormInput
                                                            {...props.input}
                                                            showError={true}
                                                            label="Interest Rate per annum"
                                                            showPlaceholder={false}
                                                            inpuType="number"
                                                            name={props.input.name}
                                                            value={props.input.value}
                                                            onChange={(e) => {
                                                                const numericValue = parseNumberForDB(e.target.value, true);
                                                                // console.log('numeric value', numericValue)
                                                                props.input.onChange(numericValue);
                                                            }}
                                                            error={props.meta.error}
                                                            touched={props.meta.touched}
                                                            onBlur={(e) => {
                                                                const value = props.input.value;
                                                                // console.log('value', value);
                                                                const formattedValue = onBlurFormatNumber(value, 2);
                                                                props.input.onChange(formattedValue);
                                                                // console.log('inputValue', value)
                                                                props.input.onBlur(e);
                                                            }}
                                                            unitPlaceHolder={'%'}
                                                            unitPosition={'right'}
                                                            maxLength={10}
                                                            isCurrency={false}
                                                        />
                                                    )}
                                                </Field>
                                            </div>

                                        </div>

                                        <div className={styles.fieldRootContainer}>

                                            <div className={styles.fieldFlexRootContainer}>

                                                <div className={styles.outerFieldContainer}>
                                                    <Field name="startDate">
                                                        {(props) => (
                                                            <MeritoDateField
                                                                {...props.input}
                                                                label="Start Date"
                                                                name={props.input.name}
                                                                onChange={props.input.onChange}
                                                                error={props.meta.error}
                                                                value={props.input.value}
                                                                touched={props.meta.touched}
                                                                showBorder={props.meta.error == datesError.withingRange ? true : false}
                                                                showError={props.meta.error == datesError.withingRange ? false : true}
                                                                onBlur={(e) => {
                                                                    // console.log('date value', props.input.value,)
                                                                    let isInvalid = false;
                                                                    let inputValue = props.input.value;
                                                                    if (props.input.value && (!dayjs(props.input.value).isValid() || (dayjs(props.input.value).isBefore(dayjs().subtract(20, 'years')) || dayjs(props.input.value).isAfter(dayjs().add(20, 'years'))))) {
                                                                        inputValue = dayjs().subtract(20, "years");
                                                                        props.input.onChange(inputValue);
                                                                        isInvalid = true;
                                                                    }
                                                                    const validationResult = validateBothDates(props.input.value, values['endDate']);
                                                                    if (!validationResult.isError) {
                                                                        // console.log('validationResult', validationResult)
                                                                        handleVariableMonths({ ...values, [props.input.name]: inputValue }, batch, change, isInvalid)
                                                                    }
                                                                    props.input.onBlur(e);
                                                                }}
                                                            />
                                                        )}
                                                    </Field>
                                                </div>

                                                <div className={styles.outerFieldContainer}>
                                                    <Field name="endDate">
                                                        {(props) => (
                                                            <MeritoDateField
                                                                {...props.input}
                                                                label="End Date"
                                                                name={props.input.name}
                                                                onChange={props.input.onChange}
                                                                error={props.meta.error}
                                                                value={props.input.value}
                                                                touched={props.meta.touched}
                                                                showBorder={props.meta.error == datesError.withingRange ? true : false}
                                                                showError={props.meta.error == datesError.withingRange ? false : true}
                                                                onBlur={(e) => {
                                                                    let isInvalid = false;
                                                                    let inputValue = props.input.value;
                                                                    if (props.input.value && (!dayjs(props.input.value).isValid() || (dayjs(props.input.value).isBefore(dayjs().subtract(20, 'years')) || dayjs(props.input.value).isAfter(dayjs().add(20, 'years'))))) {
                                                                        inputValue = dayjs().add(20, "years");
                                                                        props.input.onChange(inputValue);
                                                                        isInvalid = true;
                                                                    }
                                                                    const validationResult = validateBothDates(values['startDate'], props.input.value);
                                                                    // console.log('validationResult', validationResult)
                                                                    if (!validationResult.isError) {
                                                                        // console.log('inputValue', inputValue)
                                                                        handleVariableMonths({ ...values, [props.input.name]: inputValue }, batch, change, isInvalid)
                                                                    }
                                                                    props.input.onBlur(e);
                                                                }}
                                                            />
                                                        )}
                                                    </Field>
                                                </div>
                                            </div>
                                            <DatesErrorField />
                                        </div>

                                        <LoanFormInstallment handleVariableMonths={handleVariableMonths} validateBothDates={validateBothDates} />
                                    </div>


                                    <div className={styles.footerContainer}>
                                        <div className={styles.leftContainer}>
                                            {actionType == formActionTypes.edit &&
                                                <MeritoButton icon={<DeleteIcon />} btnText="Delete" type="destructive-ghost" onClick={() => {
                                                    setShowDeleteConfirmation(true);
                                                }} />
                                            }

                                        </div>
                                        <div className={styles.rightContainer}>
                                            <MeritoButton btnText="Cancel" type="tertiary" onClick={() => closeForm()} />
                                            <MeritoButton disabled={pristine || hasValidationErrors} btnText={actionType == formActionTypes.edit ? "Update" : "Add"} type="primary-1" onClick={() => {
                                                handleSubmit();
                                            }} />
                                        </div>
                                    </div>
                                    <ConfirmDialog
                                        // bodyStyle={{ padding: "" }}
                                        modalStyles={{ maxWidth: '450px' }}
                                        showButton={false}
                                        visible={showDeleteConfirmation}
                                        // visible={true}
                                        // visible={connectionId}
                                        toggle={() => {
                                            setShowDeleteConfirmation(!showDeleteConfirmation);
                                        }}
                                        // onClick={() =>
                                        //   progress > 100 ? setProgress(0) : setProgress(progress + 1)
                                        // }
                                        showCloseBtn={false}
                                        size={"md"}
                                    >
                                        <div className={styles.confirmationContainer}>
                                            <div className={styles.topContainer}>
                                                <div className={styles.iconContainer}>
                                                    <Exclamation />
                                                </div>
                                                <div className={styles.title}>
                                                    Are You Sure You Want to Delete?
                                                </div>
                                                <div className={styles.subTitle}>
                                                    {/* {`${categoryName} - ${values?.lenderName}`} */}
                                                </div>

                                                <div className={styles.warningContainer}>
                                                    <div className={styles.warningText}>
                                                        This will impact the numbers from the last 12 months.
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={styles.bottomContainer}>
                                                <MeritoButton onClick={() => setShowDeleteConfirmation(!showDeleteConfirmation)} size="lg" isRounded={true} btnType="button" type="secondary-2" btnText="Cancel" />
                                                <MeritoButton loading={deleteBtnLoading} size="lg" onClick={deleteLoan} isRounded={true} btnType="button" type="primary-1" btnText="Delete" />
                                            </div>
                                        </div>
                                    </ConfirmDialog>
                                </form>
                            )
                        }}
                    />
                }
            </div>
        </Modal>
    );
}

export default LoanForm;